import styled from 'styled-components'

export const OperationsContainer = styled.div`
    .first-row-container {
        display: flex;
        margin: 32px 0;
    }

    .no-outline-button {
        &:focus {
            outline: none;
        }
    }

    .no-operation {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 64px;

        p {
            padding-top: 5px;
            color: var(--gray-700);
            font-size: 13px;
        }

        i {
            color: var(--gray-500);
            font-size: 24px;
        }

        a {
            color: var(--blue-500);
            font-size: 13px;
        }
    }
`
